import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserPreferencesVariables = Types.Exact<{ [key: string]: never }>;

export type GetUserPreferences = {
  userPreferences: Pick<
    Types.UserPreferencesOutput,
    'receiveAlertAssignmentEmails' | 'displayUtcTimeZone' | 'aiPrompt' | 'theme'
  >;
};

export const GetUserPreferencesDocument = gql`
  query GetUserPreferences {
    userPreferences {
      receiveAlertAssignmentEmails
      displayUtcTimeZone
      aiPrompt
      theme
    }
  }
`;

/**
 * __useGetUserPreferences__
 *
 * To run a query within a React component, call `useGetUserPreferences` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPreferences` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPreferences({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPreferences(
  baseOptions?: Apollo.QueryHookOptions<GetUserPreferences, GetUserPreferencesVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserPreferences, GetUserPreferencesVariables>(
    GetUserPreferencesDocument,
    options,
  );
}
export function useGetUserPreferencesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetUserPreferences, GetUserPreferencesVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetUserPreferences, GetUserPreferencesVariables>(
    GetUserPreferencesDocument,
    options,
  );
}
export function useGetUserPreferencesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserPreferences, GetUserPreferencesVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetUserPreferences, GetUserPreferencesVariables>(
    GetUserPreferencesDocument,
    options,
  );
}
export type GetUserPreferencesHookResult = ReturnType<typeof useGetUserPreferences>;
export type GetUserPreferencesLazyQueryHookResult = ReturnType<
  typeof useGetUserPreferencesLazyQuery
>;
export type GetUserPreferencesSuspenseQueryHookResult = ReturnType<
  typeof useGetUserPreferencesSuspenseQuery
>;
export type GetUserPreferencesQueryResult = Apollo.QueryResult<
  GetUserPreferences,
  GetUserPreferencesVariables
>;
export function mockGetUserPreferences({
  data,
  variables,
  errors,
}: {
  data: GetUserPreferences;
  variables?: GetUserPreferencesVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: GetUserPreferencesDocument, variables },
    result: { data, errors },
  };
}
